import React, {useState} from "react"
import {Button, CircularProgress} from "@mui/material"

import {useAgent} from "@indebted/hooks/Agent"
import {api} from "@indebted/api"
import {useNotification} from "@indebted/components/Notification"

function PickUpNextCaseButton({onPickedUp}: {onPickedUp: () => void}) {
	const [agentEmail, agentName] = useAgent()
	const {notification} = useNotification()
	const [pickingUp, setPickingUp] = useState(false)

	if (!agentEmail || !agentName) {
		return <Button disabled>Pick up next case</Button>
	}

	const pickUp = () => {
		setPickingUp(true)
		api.cases
			.pickUp({AgentEmail: agentEmail, AgentName: agentName})
			.then((served) => {
				window.open(`/customers/${served.CustomerID}/cases?CaseID=${served.CaseID}`, "_blank")
				onPickedUp()
			})
			.catch((err) => notification.error(err?.Message ?? "Failed to pick up next case"))
			.finally(() => setPickingUp(false))
	}

	return (
		<Button onClick={pickUp} disabled={pickingUp}>
			{pickingUp ? <CircularProgress size={20} color="inherit" /> : "Pick up next case"}
		</Button>
	)
}

export {PickUpNextCaseButton}
